const endpoints = {
    User: {
        UserLogin: "api/users/Login",
        GetUserDetailsById: "api/users/GetById",
        UpdateUserDetails: "api/users/Update",
        VerifyUserOTP: "api/users/VerifyUserOTP",
        ForgotPassword: "api/users/ForgotPassword",
        Registration: "api/users/Registration",
        GetAllUsers: "api/users/GetAll"
    },
    Order:{
        GetAllOrders: "api/Order/GetAll",
        GetDashboardCounts: "api/Order/GetDashboardCounts",
        UpdateOrderStatus: "api/Order/UpdateStatus",
        Create: "api/Order/Create"
    },
    Address: {
        AddUserAddress: "api/Address/Create",
        GetUserAddresses: "api/Address/GetByUserId",
        GetAllCities: "api/Address/GetAllCities"
    },
    Product: {
        GetAllProducts: "api/Product/GetAll",
        GetProductById: "api/Product/GetById",
        AddProduct: "api/Product/CreateProductAndAttribute",
        UpdateProduct: "api/Product/UpdateProductWithAttribute",
        DeleteProduct: "api/Product/DeleteProductWithAttributesAsync",
        GetProductAndCategoryCounts: "api/Product/GetProductAndCategoryCounts"
    },
    Category: {
        GetAllCategories: "api/category/GetAll",
        AddCategory: "api/category/Create",
        UpdateCategory: "api/category/Update",
        DeleteCategory: "api/category/Delete"
    },
    Attributes: {
        GetAllAttributes: "api/productattribute/All",
        GetAllProductAttributesWithValues: "api/productattribute/GetAllProductAttributesWithValues",
        AddAttribute: "api/productattribute/Create",
        UpdateAttribute: "api/productattribute/Update",
        DeleteAttribute: "api/productattribute/Delete"
    },
    AttributeValues: {
        GetAllAttributeValues: "api/productattributevalue/all",
        AddAttributeValue: "api/productattributevalue/create",
        UpdateAttributeValue: "api/productattributevalue/update",
        DeleteAttributeValue: "api/productattributevalue/delete"
    },
    Notification: {
        GetAllNotifications: "api/notification/GetAllNotifications",
        MarkNotificationAsRead: "api/notification/MarkNotificationAsRead",
        MarkAllNotificationsAsRead: "api/notification/MarkAllNotificationsAsRead",
    },
    Agent:{
        GetAllAgents: "api/agent/GetAll",
        GetAgentById: "api/agent/GetById",
        AddAgent: "api/agent/Create",
        UpdateAgent: "api/agent/Update",
        DeleteAgent: "api/agent/Delete",
        GetAllAgentCommissions: "api/agent/commission/GetAll",
        MarkPaid: "api/agent/commission/MarkPaid"
    },
    WhatsApp: {
        GetSheetOrders: "api/WhatsApp/SheetOrders"
    }
};

export default endpoints;